import { render, staticRenderFns } from "./lastNews.vue?vue&type=template&id=451a5628&scoped=true&"
import script from "./lastNews.vue?vue&type=script&lang=js&"
export * from "./lastNews.vue?vue&type=script&lang=js&"
import style0 from "./lastNews.vue?vue&type=style&index=0&id=451a5628&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451a5628",
  null
  
)

export default component.exports